import { render, staticRenderFns } from "./modelBullet.vue?vue&type=template&id=39ca86ec&scoped=true&"
import script from "./modelBullet.vue?vue&type=script&lang=js&"
export * from "./modelBullet.vue?vue&type=script&lang=js&"
import style0 from "./modelBullet.vue?vue&type=style&index=0&id=39ca86ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ca86ec",
  null
  
)

export default component.exports